import { CheckboxContained, CheckboxContainedGroup } from '@homeexchange/design';
import React from 'react';
import i18n from '../../../../i18n';
var exchangeTypes = [
    {
        type: 'available',
        label: i18n.t('search:filter.exchange_type_any'),
        marker: 'is-available',
        description: i18n.t('search:filter.exchange_type_any.description')
    },
    {
        type: 'reciprocal',
        label: i18n.t('search:filter.reciprocal_label'),
        marker: 'is-reciprocal',
        description: i18n.t('search:filter.exchange_type_reciprocal.description')
    },
    {
        type: 'guest-wanted',
        label: i18n.t('search:filter.non_reciprocal_label'),
        marker: 'is-guestpoint',
        description: i18n.t('search:filter.exchange_type_guestpoint.description')
    }
];
export var ExchangeType = function (_a) {
    var exchangeType = _a.exchangeType, onChange = _a.onChange;
    return (React.createElement("div", null,
        React.createElement(CheckboxContainedGroup, { buttonWithDescription: true, showLines: 3, itemPerLine: 2 }, exchangeTypes.map(function (_a) {
            var type = _a.type, label = _a.label, marker = _a.marker, description = _a.description;
            return (React.createElement(CheckboxContained, { key: type, type: "checkbox", label: React.createElement("span", { className: "exchange-type-marker ".concat(marker) }, label), onChange: onChange, name: "exchangetype", checked: exchangeType.includes(type), value: type, description: description }));
        }))));
};
